import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-web-not-started',
  imports: [CommonModule],
  templateUrl: './not-started.component.html',
  styleUrl: './not-started.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotStartedComponent {
  readonly message = input('Not arranged');
  readonly showStartButton = input(false);
  readonly startClick = output();
}
